import React, { Component } from 'react'
import './paymentDetails.css'

class PaymentDetails extends Component {
  renderAddressDetails(transaction) {
    if (!transaction) return null

    const address = transaction.item_list.shipping_address
    if (!address) {
      return (
        <div className="billing">
          <strong>Billing details</strong>
          <span>No billing details</span>
        </div>
      )
    }

    return (
      <div className="billing">
        <strong>Billing details</strong>
        { address.recipient_name && <span>{ address.recipient_name }<br /></span> }
        { address.line1 && <span>{ address.line1 } { address.line2 || '' }<br /></span> }
        { address.city && <span>{ address.city }</span> }
        { address.country && <span>{ address.country }</span> }
        <br />
        { address.postal_code && <span>{ address.postal_code }</span> }
        { address.state && <span> { address.state }</span> }
      </div>
    )
  }

  render() {
    const { payment } = this.props

    if(!payment || !payment.transactions || payment.transactions.length === 0) {
      return null
    }

    const transaction = payment.transactions[0]
    if (!transaction) return null

    return (
      <div className="payment-details">
        { this.renderAddressDetails(transaction) }
        <div className="amount">
          <strong>Amount paid</strong>
          { transaction.amount.currency } { transaction.amount.total }
        </div>
      </div>
    );
  }
}

export default PaymentDetails
